var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{}},[_c('iframe',{ref:"iframe",staticClass:"ifr_warp",attrs:{"src":"http://www.00800.com.cn/cnhs/wqproject/index.php?app=public&mod=PCNew&act=contact","frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }